import { IFetchRecommendationsHistoryDTO } from 'modules/customer/domain/dtos';
import { ICustomerRecommendationsRepository } from 'modules/customer/domain/repositories';

export class FetchRecommendationsHistoryUseCase {
  constructor(
    private customerRecommendationsRepository: ICustomerRecommendationsRepository,
  ) {}

  public async execute({ customerId, page }: IFetchRecommendationsHistoryDTO) {
    return this.customerRecommendationsRepository.findAll({ customerId, page });
  }
}
